import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import React from 'react'
import {createCountdown} from 'Event/Dashboard/components/CountDownTimer'
import {buildLabelPlaceholders} from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig'
import {useCardsTemplate} from 'Event/template/Cards'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {useAddTranslation} from 'Event/LanguageProvider'
import {generateHashId} from 'lib/crypto/hash'

export default function NewCountDownTimerButton(props: {className?: string}) {
  const {countDownTimers} = useCardsTemplate()
  const save = useSaveTemplate()
  const addTranslation = useAddTranslation()

  const add = () => {
    const numCountdowns = Object.keys(countDownTimers).length
    const position = numCountdowns + 1

    generateHashId([
      'countdown_timer',
      position.toString(),
      Date.now().toString(),
      Math.random().toString(),
    ]).then((hashId) => {
      const id = `countdown_${hashId}`
      const timer = createCountdown(position)

      save({
        countDownTimers: {
          [id]: {
            ...timer,
            labels: buildLabelPlaceholders(id),
          },
        },
        localization: addTranslation({
          [`countdown_timer_items_${id}_labels_days`]: timer.labels.days ?? '',
          [`countdown_timer_items_${id}_labels_hours`]: timer.labels.hours,
          [`countdown_timer_items_${id}_labels_minutes`]: timer.labels.minutes,
          [`countdown_timer_items_${id}_labels_seconds`]: timer.labels.seconds,
          [`countdown_timer_items_${id}_labels_description`]: timer.labels
            .description,
          [`countdown_timer_items_${id}_labels_separator`]: timer.labels
            .separator,
        }),
      })
    })
  }

  return (
    <Grid item xs={12} className={props.className}>
      <Button
        fullWidth
        size="large"
        variant="outlined"
        color="primary"
        aria-label="add count down timer"
        onClick={add}
      >
        Add Countdown
      </Button>
    </Grid>
  )
}
